import { useState, useEffect } from 'react';

// Зворотний відлік до можливості повторного надсилання коду.
// start(seconds) запускає/перезапускає таймер; remaining — секунд, що лишилось.
// Це лише UX — бекенд однаково контролює кулдаун і ліміти.
export function useResendTimer() {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const id = setTimeout(() => setRemaining((r) => (r <= 1 ? 0 : r - 1)), 1000);
    return () => clearTimeout(id);
  }, [remaining]);

  const start = (seconds) => setRemaining(Math.max(0, Math.floor(seconds || 0)));
  return { remaining, start };
}

// Секунди -> "M:SS"
export const formatMMSS = (sec) => {
  const s = Math.max(0, Math.floor(sec));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
};
